var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lists)?_c('div',{staticClass:"table"},[_c('div',{staticClass:"grid-table"},[_c('SummaryTableHeader'),[_vm._l((_vm.lists),function(list,i){return _c('SummaryListRow',_vm._b({key:list.list.id,attrs:{"currency":_vm.currency}},'SummaryListRow',{
          list: {
            order: list.list.order,
            title: list.list.title,
            id: list.list.id,
          },
          one: list.labour,
          two: list.materials,
          three: list.tools,
          total: list.total,
          index: i + 1,
        },false))}),_c('SummaryTotal',_vm._b({attrs:{"label":_vm.$t('Total price'),"currency":_vm.currency}},'SummaryTotal',{
          one: parseFloat(_vm.summary.one) + _vm.taxes_total.labour,
          two: parseFloat(_vm.summary.two) + _vm.taxes_total.materials,
          three: parseFloat(_vm.summary.three) + _vm.taxes_total.tools,
          total: parseFloat(_vm.summary.total) + _vm.taxes_total.total,
        },false))]],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }